export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/maryam.5c3122b4.svg","height":24,"width":63,"blurWidth":0,"blurHeight":0};